import type {
  NotaFiscalComissao,
  NotaFiscalPendencia,
  RegimeTributario,
  SituacaoFiscalNota,
  StatusNotaFiscal,
  TipoPendenciaNf,
} from '@/types/comissao'

/**
 * Rótulos do fluxo da nota fiscal (AN-9 · Q36). Só tradução para a tela: estado, pendências
 * e bloqueios vêm prontos do backend.
 */

export const STATUS_NOTA: Record<
  StatusNotaFiscal,
  { rotulo: string; cor: 'default' | 'info' | 'primary' | 'success' | 'error' }
> = {
  ENVIADA: { rotulo: 'Aguardando conferência', cor: 'info' },
  DADOS_CONFIRMADOS: { rotulo: 'Dados confirmados', cor: 'info' },
  APROVADA_FISCAL: { rotulo: 'Aprovada — aguardando pagamento', cor: 'primary' },
  PAGA: { rotulo: 'Paga', cor: 'success' },
  RECUSADA: { rotulo: 'Recusada', cor: 'error' },
}

export const ROTULO_PENDENCIA: Record<TipoPendenciaNf, string> = {
  VALOR: 'Valor',
  CNPJ_TOMADOR: 'CNPJ do tomador',
  CNPJ_PRESTADOR: 'CNPJ do prestador',
  COMPETENCIA: 'Competência',
  SITUACAO_FISCAL: 'Situação fiscal',
  NUMERO: 'Número',
  POLITICA_INCOMPLETA: 'Parâmetros da NF incompletos',
}

export const ROTULO_SITUACAO: Record<SituacaoFiscalNota, string> = {
  REGULAR: 'Regular',
  CANCELADA: 'Cancelada',
  SUBSTITUIDA: 'Substituída',
  NAO_VERIFICADA: 'Não verificada',
}

export const ROTULO_REGIME: Record<RegimeTributario, string> = {
  SIMPLES_NACIONAL: 'Simples Nacional',
  MEI: 'MEI',
  LUCRO_PRESUMIDO: 'Lucro presumido',
  LUCRO_REAL: 'Lucro real',
  OUTRO: 'Outro',
}

/** Pendências ABERTAS da nota — as que bloqueiam aprovar e pagar. */
export const pendenciasAbertas = (n: NotaFiscalComissao): NotaFiscalPendencia[] =>
  (n.pendencias ?? []).filter((p) => p.status === 'ABERTA')

/** Bloqueio por pendência: o sinal pronto do backend; sem ele, a lista de abertas. */
export const temPendenciaAberta = (n: NotaFiscalComissao): boolean =>
  n.possuiPendenciaAberta ?? pendenciasAbertas(n).length > 0

/** Rótulo da pendência: o do backend; o mapa local só cobre resposta sem rótulo. */
export const rotuloPendencia = (p: NotaFiscalPendencia): string =>
  p.rotulo?.trim() || ROTULO_PENDENCIA[p.tipo] || p.tipo
